import { ApolloLink } from "./ApolloLink.js";

/**
 * @deprecated Use `ApolloLink.empty` instead. `empty` will be removed in a
 * future major version.
 */
export const empty = ApolloLink.empty;
